
import CPage from '@/components/engine/outils/constructPage/Page.vue';
import ChatShareMenu from '@/components/chat/ChatShareMenu.vue';
import guideTargets from './guideTargets'
import { actionInspectionChecks, fieldInspectionChecks, tableInspectionChecks } from './shared/rightsInspectionChecks'

export const client  = {
    mixins: [guideTargets],

    props: ['idmodule','page','form','modal','modalKey','parent','hook','customparams','customquerys','mod'],

    components: {
        CPage,
        ChatShareMenu,
        Filtre: () => import("@/components/engine/outils/constructFiltre/Filtre.vue"),
        Fields: () => import("@/components/engine/outils/constructField/Field.vue"),
        listActions: () => import("@/components/engine/outils/listActions.vue"),
        api : () => import("@/services/api"),
    },

    data: function() {
        return {
            params : {},
            // permet de définir si ce module est intégré dans une page form (nouvelle:newform ou en mode édition:editform), ou une page classique : page
            typePage : (!this.$store.getters['listForm'](this.modalKey)) ? 'page' : this.$store.getters['listForm'](this.modalKey).typeform ,
        }

    },


    mounted() {

    },

    methods: {
        actionInspectionChecks,
        fieldInspectionChecks,
        tableInspectionChecks,
        resolveModuleParams() {
            const page = this.$store.getters.specificPage(this.modalKey)
            const params = { ...(this.customparams || page?.params || {}) }
            const form = this.$store.getters.listForm(this.modalKey)
            const savedId = form?.params?.id
            // Un onglet peut conserver une copie du contexte d'ouverture.
            // Seul le marqueur de création est remplacé ; un ID explicite reste prioritaire.
            if(params.id === 'new' && form?.typeform === 'edit'
                && savedId != null && savedId !== '' && savedId !== 'new') {
                params.id = savedId
            }
            return params
        },
        shareActionReference(row, action) {
            return { type: 'action', module_id: this.idmodule, action_id: action.id, page_id: this.page,
                row_id: row && (row.id || row.event_key), context: { row,
                    params: this.customparams || this.params || {},
                    querys: this.customquerys || this.$route.query || {} } }
        }
    }
}

export const admin  = {

    props: ["module", "page",'modalKey',"buildingParameters","itemTableListe"],

    components: {
        CPage,
        Filtre: () => import("@/components/engine/outils/constructFiltre/Filtre.vue"),
        Fields: () => import("@/components/engine/outils/constructField/Field.vue"),
        listActions: () => import("@/components/engine/outils/listActions.vue"),
        Autocomplete   : () => import('@/components/fields/autocomplete.vue'),
        SimpleTable : () => import('@/components/engine/outils/simpleTable.vue'),
        SwitchC: () => import("@/components/fields/switch.vue"),
        TextField: () => import("@/components/fields/textfield.vue"),
        Select: () => import("@/components/fields/select.vue"),
        ArrayTable   : () => import('@/components/fields/arrayTable.vue'),
        paramDialog: () => import("@/components/engine/outils/paramDialog.vue"),
        datePicker   : () => import('@/components/fields/datePicker.vue'),
        groupConditions : () => import('@/components/engine/outils/constructConditions/Conditions.vue'),
        Cventilation: () => import("@/components/engine/outils/constructVentilation/Ventilation.vue"),
        texteditor : () => import("@/components/fields/texteditor.vue"),

    },

    data: function() {
        return {
            params : {},
        }

    },


    mounted() {

    }
}
